/*
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
*/

import React from "react";
import ReactDOM from "react-dom";
//when using react 18
//import ReactDOM from "react-dom/client"
import "./index.css";
import App from "./App";
import {persistor, store} from "./app/store";
import {Provider} from "react-redux";
import {PersistGate} from "redux-persist/es/integration/react";
import { QueryClient, QueryClientProvider } from "react-query";
import {SnackbarProvider} from "notistack";
import * as serviceWorker from "./serviceWorker";

const queryClient = new QueryClient();


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <QueryClientProvider client={queryClient}>
          <PersistGate persistor={persistor}>
            <App />
          </PersistGate>
        </QueryClientProvider>
      </SnackbarProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

/*
TO USE REACT 18;
BUT: FETCHING IS NOT SO SIMPLE (DOUBLE QUERIES IN DEV MODE)
-> NEED TO MAKE USE OF useQuery
const container = document.getElementById("root");
const root = ReactDOM.createRoot(container!);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <QueryClientProvider client={queryClient}>
          <PersistGate persistor={persistor}>
            <App />
          </PersistGate>
        </QueryClientProvider>
      </SnackbarProvider>
    </Provider>
  </React.StrictMode>
);

*/


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
